module.exports = __webpack_public_path__ + "c286fd333daf77c450d68d413dd3bfa6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/UA_icon_sm_2x.png
// module id = 1743
// module chunks = 1